import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../component/layout';

import ApprovalWorkflowsTab from './approvals';
import RFQGradingTab from './rfq_grading_tab';

function ApprovalRFQManagement() {
    const [activeTab, setActiveTab] = useState('approval-workflows');
    
    return (
        <Layout>
            <div className="page-header">
                <div className="page-block">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to={"/facility/"}>Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={"/facility/procurement_management"}>
                                        Procurement
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active">
                                    Settings
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card">
                                                <div className="card-body py-0">
                                                    <ul className="nav nav-tabs profile-tabs">
                                                        <li className="nav-item">
                                                            <button
                                                                className={`nav-link ${activeTab === 'approval-workflows' ? 'active' : ''}`}
                                                                onClick={() => setActiveTab('approval-workflows')}
                                                                type="button"
                                                            >
                                                                <i className="ti ti-check-circle me-2"></i>Approval Workflows
                                                            </button>
                                                        </li>
                                                        <li className="nav-item">
                                                            <button
                                                                className={`nav-link ${activeTab === 'rfq-grading' ? 'active' : ''}`}
                                                                onClick={() => setActiveTab('rfq-grading')}
                                                                type="button"
                                                            >
                                                                <i></i>RFQ Grading
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <div className="tab-content" style={{ paddingTop: '1rem' }}>
                                                {activeTab === 'approval-workflows' && (
                                                    <ApprovalWorkflowsTab />
                                                )}
                                                {activeTab === 'rfq-grading' && (
                                                    <RFQGradingTab />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default ApprovalRFQManagement;